import React, { useCallback, useEffect, useMemo } from "react";
import JamezzTableV2, { useReloadState } from "../../../../../components/JamezzTable/V2/JamezzTableV2";
import useJTFilter from "../../../../../components/JamezzTable/V2/useJTFilter";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";
import { Box, GridLegacy, TableCell } from "@mui/material";
import { formatTime } from "../../../../../licensing/utils/formatDate";
import { Wallpaper } from "@mui/icons-material";

const endPoint = "core/posSyncLogs";

function PosSyncLogs(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const { posSync } = props;

  useEffect(() => {
    const updateInterval = setInterval(() => {
      updateReloadState();
    }, 5000);
    return () => {
      clearInterval(updateInterval);
    };
  }, []);
  const [textField, searchFilter] = useJTFilter("test");
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "Log",
        label: <TranslationWrapper tDefault={"Log"} tKey={"posSyncs.Log"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "is error",
        label: <TranslationWrapper tDefault={"is error"} tKey={"posSyncs.is error"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },

      {
        id: "created_at",
        label: <TranslationWrapper tDefault={"Created at"} tKey={"posSyncs.created_at"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>
          <Box style={{ overflow: "auto", maxHeight: 600, maxWidth: 600 }}>
            {Array.isArray(row.content) ? (
              <pre>
                <code>{JSON.stringify(row.content, null, 2)}</code>
              </pre>
            ) : (
              row.content
            )}
          </Box>
        </TableCell>
        <TableCell>{row.is_error ? "YES" : "no"}</TableCell>

        <TableCell>{formatTime(new Date(row.created_at))}</TableCell>
      </>
    );
  }, []);

  const filters = useMemo(() => {
    let filters = { pos_sync_id: { field: "pos_sync_id", value: posSync.id, operator: "=" } };

    return filters;
  }, [searchFilter, props.filters]);

  return (
    <div>
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <JamezzTableV2
            checkboxSelection={false}
            dense={true}
            endPoint={endPoint}
            filters={filters}
            headerIcon={<Wallpaper />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={() => []}
            tableTitle={
              <>
                <TranslationWrapper tDefault={"Logs of pos sync: "} tKey={"posSyncs.table.title"} /> #{posSync.id} -{" "}
                {posSync.type}{" "}
              </>
            }
            uuid={"PosSyncsLogs-aksldjalksjdloajsdlk"}
          />
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default PosSyncLogs;
